@if (waveService.isWaveActive() || waveService.isEinsichtWaveActivation()) {
  <div class="wave-background"></div>
}
